module.exports = __webpack_public_path__ + "static/media/participles4_img.188c146e.JPG";